var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container,attrs:{"id":"hud-aghanims"}},[_c('aghanims-tooltip',{attrs:{"position":"top","hero":_vm.hero}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }